import { hbs } from 'ember-cli-htmlbars';
export default hbs("<td class=\'table__td\' ...attributes>\n  {{~yield~}}\n</td>")